export const NGO_BY_ID_REQUEST = 'NGO_BY_ID_REQUEST';
export const NGO_BY_ID_SUCCESS = 'NGO_BY_ID_SUCCESS';
export const NGO_BY_ID_FAIL = 'NGO_BY_ID_FAIL';
export const NGO_BY_ID_RESET = 'NGO_BY_ID_RESET';

export const NGO_LIST_REQUEST = 'NGO_LIST_REQUEST';
export const NGO_LIST_SUCCESS = 'NGO_LIST_SUCCESS';
export const NGO_LIST_FAIL = 'NGO_LIST_FAIL';
export const NGO_LIST_RESET = 'NGO_LIST_RESET';

export const UPDATE_NGO_IS_ACTIVE_REQUEST = 'UPDATE_NGO_IS_ACTIVE_REQUEST';
export const UPDATE_NGO_IS_ACTIVE_SUCCESS = 'UPDATE_NGO_IS_ACTIVE_SUCCESS';
export const UPDATE_NGO_IS_ACTIVE_FAIL = 'UPDATE_NGO_IS_ACTIVE_FAIL';

export const UPDATE_NGO_REQUEST = 'UPDATE_NGO_REQUEST';
export const UPDATE_NGO_SUCCESS = 'UPDATE_NGO_SUCCESS';
export const UPDATE_NGO_FAIL = 'UPDATE_NGO_FAIL';

export const ADD_NGO_REQUEST = 'ADD_NGO_REQUEST';
export const ADD_NGO_SUCCESS = 'ADD_NGO_SUCCESS';
export const ADD_NGO_FAIL = 'ADD_NGO_FAIL';
export const ADD_NGO_RESET = 'ADD_NGO_RESET';

export const DELETE_NGO_REQUEST = 'DELETE_NGO_REQUEST';
export const DELETE_NGO_SUCCESS = 'DELETE_NGO_SUCCESS';
export const DELETE_NGO_FAIL = 'DELETE_NGO_FAIL';

export const NGO_ARRIVAL_REQUEST = 'NGO_ARRIVAL_REQUEST';
export const NGO_ARRIVAL_SUCCESS = 'NGO_ARRIVAL_SUCCESS';
export const NGO_ARRIVAL_FAIL = 'NGO_ARRIVAL_FAIL';

export const UPDATE_NGO_ARRIVAL_REQUEST = 'UPDATE_NGO_ARRIVAL_REQUEST';
export const UPDATE_NGO_ARRIVAL_SUCCESS = 'UPDATE_NGO_ARRIVAL_SUCCESS';
export const UPDATE_NGO_ARRIVAL_FAIL = 'UPDATE_NGO_ARRIVAL_FAIL';

export const PRE_REGISTER_NGO_CREATE_REQUEST = 'PRE_REGISTER_NGO_CREATE_REQUEST';
export const PRE_REGISTER_NGO_CREATE_SUCCESS = 'PRE_REGISTER_NGO_CREATE_SUCCESS';
export const PRE_REGISTER_NGO_CREATE_FAIL = 'PRE_REGISTER_NGO_CREATE_FAIL';
export const PRE_REGISTER_NGO_CREATE_RESET = 'PRE_REGISTER_NGO_CREATE_RESET';

export const PRE_REGISTER_NGO_REQUEST = 'PRE_REGISTER_NGO_REQUEST';
export const PRE_REGISTER_NGO_SUCCESS = 'PRE_REGISTER_NGO_SUCCESS';
export const PRE_REGISTER_NGO_FAIL = 'PRE_REGISTER_NGO_FAIL';
export const PRE_REGISTER_NGO_RESET = 'PRE_REGISTER_NGO_RESET';

export const PRE_REGISTER_NGO_LIST_REQUEST = 'PRE_REGISTER_NGO_LIST_REQUEST';
export const PRE_REGISTER_NGO_LIST_SUCCESS = 'PRE_REGISTER_NGO_LIST_SUCCESS';
export const PRE_REGISTER_NGO_LIST_FAIL = 'PRE_REGISTER_NGO_LIST_FAIL';
export const PRE_REGISTER_NGO_LIST_RESET = 'PRE_REGISTER_NGO_LIST_RESET';

export const PRE_REGISTER_NGO_UPDATE_REQUEST = 'PRE_REGISTER_NGO_UPDATE_REQUEST';
export const PRE_REGISTER_NGO_UPDATE_SUCCESS = 'PRE_REGISTER_NGO_UPDATE_SUCCESS';
export const PRE_REGISTER_NGO_UPDATE_FAIL = 'PRE_REGISTER_NGO_UPDATE_FAIL';
